module.exports = __webpack_public_path__ + "img/emotionWheel1.4e56e240.png";